const styles = {
  sectionText:
    'text-white font-bold text-[40px] sm:text-[50px] md:text-[80px] ' +
    'lg:text-[90px] xl:text-[100px] 2xl:text-[90px] 3xl:text-[120px] ' +
    '4xl:text-[150px]',
  paragraphText:
    'text-secondary font-normal text-base sm:text-base md:text-lg ' +
    'lg:text-lg xl:text-xl 2xl:text-xl 3xl:text-[22px] 4xl:text-[24px] ' +
    'leading-relaxed sm:leading-relaxed md:leading-relaxed ' +
    'lg:leading-relaxed xl:leading-snug 2xl:leading-snug ' +
    '3xl:leading-[32px] 4xl:leading-[35px]',
};

export { styles };
